import { SnackbarOrigin } from '@mui/material';

import {
  authCard,
  authSmallText,
  authTitle,
  colors,
  fonts,
  thinScrollbar,
} from '../../theme';

const styles = {
  dialog: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.72)',
    },
  },
  // Same width as the card of the auth pages: Container maxWidth "sm" (600px) minus its gutters (24px).
  // No margin: the dialog's flex container centers it in the viewport.
  paperProps: {
    sx: {
      ...authCard,
      position: 'relative',
      width: { xs: 'calc(100% - 32px)', sm: 552 },
      maxWidth: 'none',
      maxHeight: 'calc(100% - 32px)',
      m: 0,
      boxSizing: 'border-box',
      backgroundImage: 'none',
      boxShadow: '0 24px 64px rgba(0, 0, 0, 0.7)',
      ...thinScrollbar,
    },
  },
  close: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: colors.textSecondary,
    '&:hover': {
      color: colors.text,
      backgroundColor: colors.surfaceRaised,
    },
  },
  // Same as the title of the auth pages (h4); side room for the close button.
  title: {
    ...authTitle,
    px: 3,
  },
  // Same as the subtitle of the forgot password page.
  text: {
    ...authSmallText,
    mt: 1,
    mb: 2,
    fontSize: 13.5,
    textAlign: 'center',
  },
  later: {
    alignSelf: 'center',
    p: 0.5,
    border: 0,
    backgroundColor: 'transparent',
    fontFamily: fonts.text,
    fontSize: 13,
    fontWeight: 500,
    color: colors.textSubtle,
    cursor: 'pointer',
    '&:hover': {
      color: colors.text,
    },
  },
  toastOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as SnackbarOrigin,
  // Same place as the toasts of the forms.
  toast: {
    top: '80px !important',
  },
  toastAlert: {
    fontFamily: fonts.text,
    fontSize: 13.5,
    alignItems: 'center',
  },
};

export default styles;
